import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';
import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

const REINSURANCE_BANNER_HEIGHT = 78;

export const Container = styled.div`
  background-color: ${COLORS.GROUND_UNDERGROUND};
  padding: 0 16px;
`;

export const ContentContainer = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;

  gap: 16px;
  width: 100%;
  max-width: 1085px;
  height: ${REINSURANCE_BANNER_HEIGHT}px;

  ${media.XL`
    justify-content: center;
  `}
`;

export const ItemContainer = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${media.XL`
    flex: 1;
    flex-direction: row;
    justify-content: center;
  `}
`;

// Texte affiché en mobile
export const TitleShort = styled.span`
  font-size: 12px;
  font-weight: 700;
  font-family: ${FONTS.ARTZ};
  text-align: center;

  ${media.XL`
    display: none;
  `}
`;

// Wrapper pour le titre+texte en desktop
export const ItemContentContainer = styled.div`
  display: none;

  ${media.XL`
    display: block;
  `}
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  font-family: ${FONTS.ARTZ};
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 12px;
`;
